import { render } from "./SignerPreview.vue?vue&type=template&id=4f086c52&scoped=true"
import script from "./SignerPreview.vue?vue&type=script&lang=js"
export * from "./SignerPreview.vue?vue&type=script&lang=js"

import "./SignerPreview.vue?vue&type=style&index=0&id=4f086c52&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f086c52"]])

export default __exports__